import { object } from 'prop-types';
import React from 'react';

import TextField from '../../FormFields/TextField';

const PercentActiveFields = ({
    errors,
    touched,
    values,
    ...props
}) => (
    <>
        <TextField
            autoComplete="off"
            errors={errors.ruleAggregateCount}
            helperText="Enter a percentage value (i.e. 50 for 50%)"
            label={`${process.env.isRuleAggregateChange ? 'Aggregate ' : ''}Percent Active`}
            name="ruleAggregateCount"
            required
            touched={touched.ruleAggregateCount}
            type="number"
            value={values.ruleAggregateCount}
            {...props}
        />
        <TextField
            autoComplete="off"
            errors={errors.ruleAggregateDuration}
            helperText={`Enter a value in ${process.env.isRuleAggregateChange ? 'minutes' : 'hours'}`}
            label={`${process.env.isRuleAggregateChange ? 'Aggregate ' : ''}Duration`}
            name="ruleAggregateDuration"
            required
            touched={touched.ruleAggregateDuration}
            type="number"
            value={values.ruleAggregateDuration}
            {...props}
        />
    </>
);

PercentActiveFields.defaultProps = {
    errors:  {},
    touched: {},
    values:  {}
};

PercentActiveFields.propTypes = {
    errors:  object,
    touched: object,
    values:  object
};

export default PercentActiveFields;
